/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DropMemberStatusResponse
 */
export interface DropMemberStatusResponse {
    /**
     * 
     * @type {boolean}
     * @memberof DropMemberStatusResponse
     */
    hasMembership: boolean;
    /**
     * False when the experience publishes a termsVersion this member does not hold — including a member carried over from a prior campaign on the same door.
     * @type {boolean}
     * @memberof DropMemberStatusResponse
     */
    attestationOnFile: boolean;
    /**
     * The terms version this door currently requires. Absent when it requires none.
     * @type {string}
     * @memberof DropMemberStatusResponse
     */
    requiredTermsVersion?: string;
    /**
     * Link to the full official rules for the accept prompt.
     * @type {string}
     * @memberof DropMemberStatusResponse
     */
    officialRulesUrl?: string;
    /**
     * 
     * @type {boolean}
     * @memberof DropMemberStatusResponse
     */
    countryOnFile: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DropMemberStatusResponse
     */
    stateRequired: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof DropMemberStatusResponse
     */
    canCodeless?: boolean;
}

/**
 * Check if a given object implements the DropMemberStatusResponse interface.
 */
export function instanceOfDropMemberStatusResponse(value: object): value is DropMemberStatusResponse {
    if (!('hasMembership' in value) || value['hasMembership'] === undefined) return false;
    if (!('attestationOnFile' in value) || value['attestationOnFile'] === undefined) return false;
    if (!('countryOnFile' in value) || value['countryOnFile'] === undefined) return false;
    if (!('stateRequired' in value) || value['stateRequired'] === undefined) return false;
    return true;
}

export function DropMemberStatusResponseFromJSON(json: any): DropMemberStatusResponse {
    return DropMemberStatusResponseFromJSONTyped(json, false);
}

export function DropMemberStatusResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropMemberStatusResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'hasMembership': json['hasMembership'],
        'attestationOnFile': json['attestationOnFile'],
        'requiredTermsVersion': json['requiredTermsVersion'] == null ? undefined : json['requiredTermsVersion'],
        'officialRulesUrl': json['officialRulesUrl'] == null ? undefined : json['officialRulesUrl'],
        'countryOnFile': json['countryOnFile'],
        'stateRequired': json['stateRequired'],
        'canCodeless': json['canCodeless'] == null ? undefined : json['canCodeless'],
    };
}

export function DropMemberStatusResponseToJSON(json: any): DropMemberStatusResponse {
    return DropMemberStatusResponseToJSONTyped(json, false);
}

export function DropMemberStatusResponseToJSONTyped(value?: DropMemberStatusResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'hasMembership': value['hasMembership'],
        'attestationOnFile': value['attestationOnFile'],
        'requiredTermsVersion': value['requiredTermsVersion'],
        'officialRulesUrl': value['officialRulesUrl'],
        'countryOnFile': value['countryOnFile'],
        'stateRequired': value['stateRequired'],
        'canCodeless': value['canCodeless'],
    };
}

